<div class="mat-tab-links" (cdkObserveContent)="_alignInkBar()"><ng-content></ng-content><mat-ink-bar></mat-ink-bar></div>


// WEBPACK FOOTER //
// ./node_modules/@angular/material/tabs/typings/index.d.ts.MatTabNav.html